import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { TourProvider } from "./components/tour";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Mounted at /curate/ in both standalone and bundle deployments —
          must match vite.config.ts's `base`. */}
      <BrowserRouter basename="/curate">
        <TourProvider>
          <App />
        </TourProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
